<template>
  <div class="ts-space-y-2">
    <ts-loading-banner :loading="loading">
      <div class="row mb-3">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('kotBotPrinter.branchName')
          }}</label>
          <Select v-model="model.branch_id">
            <Option
              v-for="item in branches"
              :value="item.branch_id"
              :key="item.branch_id"
              :label="item.branch_name_en"
            >
              {{ item.branch_name_en }}
            </Option>
          </Select>
          <div
            class="invalid-feedback ts-text-xs"
            v-if="errors.has('branch_id')"
          >
            {{ errors.first('branch_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('kotBotPrinter.receiptType')
          }}</label>
          <Select v-model="model.receipt_type">
            <Option
              v-for="(type, i) in types"
              :value="type"
              :key="i"
              :label="type"
            >
              {{ type }}
            </Option>
          </Select>
          <div
            class="invalid-feedback ts-text-xs"
            v-if="errors.has('receipt_type')"
          >
            {{ errors.first('receipt_type') }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('kotBotPrinter.printerName')
          }}</label>
          <input
            v-model="model.printer_name"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('printer_name') }"
          />
          <div
            class="invalid-feedback ts-text-xs"
            v-if="errors.has('printer_name')"
          >
            {{ errors.first('printer_name') }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('kotBotPrinter.productGroup')
          }}</label>
          <Select
            v-model="model.pro_group_id"
            multiple
            :filterable="true"
            :filter-by-label="true"
            size="large"
          >
            <Option
              v-for="item in groups"
              :value="item.pro_group_id"
              :key="item.pro_group_id"
              :label="item.pro_group_name_en"
            >
              {{ item.pro_group_name_en }}
            </Option>
          </Select>
          <div
            class="invalid-feedback ts-text-xs"
            v-if="errors.has('pro_group_id')"
          >
            {{ errors.first('pro_group_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      model: {
        branch_id: null,
        receipt_type: null,
        printer_name: null,
        pro_group_id: []
      },
      types: ['KOT', 'BOT']
    }
  },
  created() {
    this.fetchBefore()
  },
  computed: {
    ...mapState('restaurantSale/kotBotPrinter', ['branches', 'groups']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('restaurantSale/kotBotPrinter', ['fetchPreData']),
    fetchBefore() {
      this.loading = true
      this.fetchPreData().finally(() => {
        this.loading = false
      })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
